import React from 'react';
import LegalLayout from './LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout title="Política de Privacidad">
      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">1. Responsable del Tratamiento de Datos</h2>
        <p>El responsable del tratamiento de los datos en este sitio web es:</p>
        <ul className="list-none space-y-2 text-etera-charcoal">
          <li><strong>Gisselle Mendez</strong></li>
          <li>Nemesi Valls 44 Attico 2, 08210 Barberà del Vallès</li>
          <li>Barcelona, España</li>
          <li>
            <strong>Correo electrónico:</strong>{' '}
            <a href="mailto:contact@eteradragonhouse.com" className="hover:text-etera-gold underline transition-colors">
              contact@eteradragonhouse.com
            </a>
          </li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">2. Recopilación y Tratamiento de Datos</h2>
        <p>
          Recopilamos y tratamos datos personales solo cuando es necesario para proporcionar un sitio web funcional, sus contenidos y nuestros servicios.
        </p>
        <p>
          Si se pone en contacto con nosotros por correo electrónico, los datos que proporcione (por ejemplo, su dirección de correo electrónico, nombre y el contenido de su mensaje) serán almacenados por nosotros para poder procesar su solicitud y responder a su consulta.
        </p>
        <p className="italic">Este sitio web no utiliza cookies ni tecnologías de seguimiento similares.</p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">3. Boletín informativo (Newsletter) y SendFox</h2>
        <p>
          Si desea recibir el boletín ofrecido en el sitio web, requerimos una dirección de correo electrónico suya. Utilizamos <strong>SendFox</strong>, un servicio operado por Sumo Group Inc., 1305 E 6th St #3, Austin, TX 78702, EE. UU., para enviar nuestros boletines.
        </p>
        <p>
          Al registrarse para recibir nuestro boletín, los datos que proporcione (como su dirección de correo electrónico) se transmiten a SendFox y se almacenan en sus servidores en los Estados Unidos.
        </p>
        <p>
          La base legal para el tratamiento de sus datos para el envío del boletín es su consentimiento explícito (Art. 6 apdo. 1 letra a del RGPD). Puede revocar su consentimiento para el almacenamiento de los datos, la dirección de correo electrónico y su uso para el envío del boletín en cualquier momento, por ejemplo, a través del enlace para darse de baja ("unsubscribe") que aparece en cada boletín.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">4. Base Legal para el Tratamiento</h2>
        <p>
          El tratamiento de los datos facilitados al contactarnos se basa en su consentimiento (Art. 6 apdo. 1 letra a del RGPD) o para la ejecución de un contrato o medidas precontractuales (Art. 6 apdo. 1 letra b del RGPD).
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">5. Conservación de los Datos</h2>
        <p>
          Conservamos sus datos personales solo durante el tiempo necesario para el propósito respectivo o según lo exijan los plazos de conservación legales. Después de este período, los datos correspondientes se eliminan de forma rutinaria.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">6. Sus Derechos</h2>
        <p>
          En virtud del RGPD, tiene derecho a solicitar en cualquier momento información sobre sus datos personales almacenados. Además, tiene derecho a solicitar la rectificación, limitación del tratamiento o supresión de estos datos. 
        </p>
        <p>
          También tiene derecho a la portabilidad de los datos y el derecho a presentar una reclamación ante la autoridad de control competente (Agencia Española de Protección de Datos - AEPD).
        </p>
      </section>

      <div className="pt-8 border-t border-etera-gold/20">
        <p className="text-sm">
          Para ejercer sus derechos, simplemente envíe un correo electrónico a:{' '}
          <a href="mailto:contact@eteradragonhouse.com" className="font-semibold hover:text-etera-gold transition-colors">
            contact@eteradragonhouse.com
          </a>
        </p>
      </div>
    </LegalLayout>
  );
}